package com.eladfinish.bible.contest.di

import com.eladfinish.bible.contest.features.deeplink.deepLinkModule
import com.eladfinish.bible.contest.features.installTime.di.installTimeModule
import com.eladfinish.bible.contest.features.review.reviewModule
import com.eladfinish.bible.contest.features.review.reviewPlatformModule
import com.eladfinish.bible.contest.features.share.shareModule
import com.eladfinish.bible.contest.features.share.sharePlatformModule
import org.koin.dsl.module

val featureModule = module {
    includes(sharePlatformModule)
    includes(shareModule)

    includes(deepLinkModule)

    includes(installTimeModule)

    includes(reviewPlatformModule)
    includes(reviewModule)
}
